import { z } from "zod";

export const announcementSeveritySchema = z.enum(["info", "warning", "critical"]);
export type AnnouncementSeverity = z.infer<typeof announcementSeveritySchema>;

// Server response shape — ISO strings on the wire, parsed to Dates in
// the UI where needed via the formatDate helpers. Title is required;
// body, severity, dismissible, and the two timestamps all have server
// defaults but the read shape always returns them populated.
export const announcementSchema = z.object({
  id: z.string(),
  title: z.string(),
  body: z.string(),
  severity: announcementSeveritySchema,
  dismissible: z.boolean(),
  startsAt: z.string().nullable(),
  expiresAt: z.string().nullable(),
  createdBy: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export const announcementArraySchema = z.array(announcementSchema);
export type Announcement = z.infer<typeof announcementSchema>;

// Mutation input — accepts ISO strings (or null) for the timestamps;
// the API layer converts to Date before persisting. Severity falls back
// to "info" if omitted; dismissible defaults to true.
export const createAnnouncementSchema = z.object({
  title: z.string().min(1, "Title is required"),
  body: z.string(),
  severity: announcementSeveritySchema.default("info"),
  dismissible: z.boolean().default(true),
  startsAt: z.string().nullable().default(null),
  expiresAt: z.string().nullable().default(null),
});
export type CreateAnnouncementInput = z.infer<typeof createAnnouncementSchema>;

export const updateAnnouncementSchema = z.object({
  title: z.string().min(1).optional(),
  body: z.string().optional(),
  severity: announcementSeveritySchema.optional(),
  dismissible: z.boolean().optional(),
  startsAt: z.string().nullable().optional(),
  expiresAt: z.string().nullable().optional(),
});
export type UpdateAnnouncementInput = z.infer<typeof updateAnnouncementSchema>;
